import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { WarrantyVerification } from 'api';
import { ParseKeys } from 'i18next';

//Create a common component somewhere
export const WarrantyWarningAlert = ({
	errors,
}: {
	errors: WarrantyVerification | null;
}): React.JSX.Element => {
	const { t } = useTranslation(['productInOperation', 'productType']);

	const formatWarning = (
		stringToSplit: string,
		formatLabel: ParseKeys<['productInOperation']>
	) => {
		const arr = stringToSplit.split('_');

		const individualData = {
			productCategory: t(
				`productType:${arr[0]}` as ParseKeys<
					['productInOperation', 'productInOperation']
				>
			),
			serialNumber: arr[1],
		};

		return t(formatLabel, individualData);
	};

	return (
		<>
			{errors &&
			(errors.shelfTime.length > 0 || errors.warrantyVoid.length) ? (
				<Alert severity="warning" sx={{ mt: 1 }}>
					{errors.shelfTime && errors.shelfTime.length > 0 && (
						<>
							<Typography>
								{t(
									'productInOperation:shelf-time-error-message-explanation'
								)}
							</Typography>
							<ul>
								{errors.shelfTime.map((warn) => (
									<li key={warn}>
										{formatWarning(
											warn,
											'productInOperation:shelf-time-error-message-failed-part'
										)}
									</li>
								))}
							</ul>
							<Typography>
								{t(
									'productInOperation:shelf-time-error-message-further-information'
								)}
							</Typography>
						</>
					)}
					{errors.warrantyVoid && errors.warrantyVoid.length > 0 && (
						<>
							<ul>
								{errors.warrantyVoid.map((warn) => (
									<li key={warn}>
										{formatWarning(
											warn,
											'productInOperation:warranty-void-error-message'
										)}
									</li>
								))}
							</ul>
						</>
					)}
				</Alert>
			) : (
				<></>
			)}
		</>
	);
};
